export default "{% block datenschutz %}\n\n{% endblock %}";